const Card = ({ children, className = '', onClick }) => {
	return (
		<div
			className={`card ${className} ${onClick ? 'cursor-pointer hover:shadow-2xl transition-shadow' : ''}`}
			onClick={onClick}
		>
			{children}
		</div>
	);
};

export default Card;
